

















































































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class LicenseInfo extends Vue {
  @Prop({ default: () => [] }) licenses!: any[];

  get groupedLicenses() {
    const grouped = this.licenses.reduce((groups: any, license: any) => {
      const tenantId = license.tenant_id || 'Tenant ID Bulunamadı'; // Tenant ID ekleniyor
      const buroName = license.buroName || 'Büro Adı Bulunamadı';

      // Gruplama: tenant_id ve buroName ile grup oluşturuyoruz
      const groupKey = `${tenantId} - ${buroName}`;

      if (!groups[groupKey]) {
        groups[groupKey] = { buroName, tenantId, licenses: [] };
      }
      groups[groupKey].licenses.push(license);
      return groups;
    }, {});

    return Object.values(grouped);
  }


  formatDate(date: Date | string | null): string {
    if (!date) return '';
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
    if (date instanceof Date && !isNaN(date.getTime())) {
      return date.toISOString().split('T')[0];
    }
    const parsedDate = new Date(date as string);
    return isNaN(parsedDate.getTime()) ? '' : parsedDate.toISOString().split('T')[0];
  }

  confirmEndDate(license: any) {
    license.new_licenses_date = license.tempEndDate;
    license.endDateMenu = false;
  }

  async handleSave() {
    try {
      await this.$emit('save', this.licenses);
    } catch (error) {
      console.log(error);
    }
  }

  handleClose() {
    this.$emit('close');
  }
}
